var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.003 10a2 2 0 1 1 .002-4.001A2 2 0 0 1 10.003 10m0-6a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 10c-3.17 0-6.17-2.29-7.9-6 1.73-3.71 4.73-6 7.9-6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6m9.92-6.4c-2.02-4.69-5.82-7.6-9.92-7.6s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8c2.02 4.69 5.82 7.6 9.92 7.6s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8","fill":"#868797","fillRule":"evenodd"}));
}

Eye.defaultProps = {"width":"30","viewBox":"0 0 20 16"};

module.exports = Eye;

Eye.default = Eye;
